import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import CheckoutShippingState from "@store/Store/Pages/CheckoutShipping/CheckoutShippingState";
import { Draft } from "immer";

const initialState: CheckoutShippingState = {
    autocompleteAddress: false,
	saveOneTimeToAddressBook: false,
};

const reducer = {
	"Store/Pages/CheckoutShipping/ToggleSaveOneTimeToAddressBook": (draft: Draft<CheckoutShippingState>) => {
        draft.saveOneTimeToAddressBook = !draft.saveOneTimeToAddressBook;
    },
    "Store/Pages/CheckoutShipping/BeginAutocomplete": (draft: Draft<CheckoutShippingState>) => {
        draft.autocompleteAddress = true;
    },
    "Store/Pages/CheckoutShipping/CompleteAutocomplete": (
        draft: Draft<CheckoutShippingState>,
    ) => {
        draft.autocompleteAddress = false;
    },
};

const checkoutShippingReducer = createTypedReducerWithImmer(initialState, reducer);

export default checkoutShippingReducer; 
